/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GCPNetworkCreateSchema
 */
export interface GCPNetworkCreateSchema {
    /**
     * 
     * @type {string}
     * @memberof GCPNetworkCreateSchema
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof GCPNetworkCreateSchema
     */
    name?: string;
}

/**
 * Check if a given object implements the GCPNetworkCreateSchema interface.
 */
export function instanceOfGCPNetworkCreateSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GCPNetworkCreateSchemaFromJSON(json: any): GCPNetworkCreateSchema {
    return GCPNetworkCreateSchemaFromJSONTyped(json, false);
}

export function GCPNetworkCreateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GCPNetworkCreateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': !exists(json, 'link') ? undefined : json['link'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function GCPNetworkCreateSchemaToJSON(value?: GCPNetworkCreateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
        'name': value.name,
    };
}

